import {Injectable} from "@angular/core";
import {LicenseProxy} from "./license.proxy";
import {HttpObservable} from "../../common/http-helpers/http.wrapper";
import {BehaviorSubject, Observable} from "rxjs";

@Injectable({
  providedIn: "root"
})
export class LicenseService {
  private licenseValidated = new BehaviorSubject<boolean>(undefined);

  constructor(private licenseProxy: LicenseProxy) {
      this.validateLicense().subscribe(res => {
        this.licenseValidated.next(res);
      });
  }

  public licenseValidatedObs(): Observable<boolean> {
    return this.licenseValidated.asObservable();
  }

  private validateLicense(): HttpObservable<boolean> {
    return this.licenseProxy.validateLicense();
  }

}
